import { blue } from "@ant-design/colors";
import { Column, Heading, Row } from "core/util-styled-components";
import React from "react";
import UserInfo from "Templates/barraLateral/components/UserInfo";
import ButtonBars from "./ButtonBars";
import { useMediaQueryCustom } from "App/Hooks/useMediaQueryCustom";
interface tituloProps {
  label: string;
  extra?: any;
  titleRender?: any;
}

function Titulo({ label, extra, titleRender }: tituloProps) {
  const { isTabletOrMobile } = useMediaQueryCustom();

  return (
    <Row
      addShadow
      justifyContent="space-between"
      style={{
        width: "100%",
        padding: isTabletOrMobile ? "1em 1em" : ".5em 1em",
        backgroundColor: "white",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        borderBottom: "1px dashed " + blue[1],
      }}
    >
      <Row gap=".5em" alignItems="center">
        <ButtonBars />
        <Heading variant="h3">{label}</Heading>
        {titleRender && titleRender()}
      </Row>

      <Row>
        <UserInfo responsive />
        {extra}
      </Row>
    </Row>
  );
}

export default Titulo;
